var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarSignGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#BFBEC6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.73 9.85372C10.7358 9.06258 10.4231 8.4369 9.79926 7.99504C9.31746 7.65484 8.73278 7.47738 8.16727 7.30685C6.98923 6.94972 6.6475 6.76161 6.6475 6.19825C6.6475 5.57074 7.463 5.34747 8.16114 5.34747C8.66957 5.34747 9.25452 5.50555 9.61779 5.73982L10.338 4.62444C9.86321 4.31665 9.21342 4.10671 8.57178 4.04155V3H7.24324V4.11459C6.06228 4.37438 5.31834 5.14623 5.31834 6.19825C5.31834 6.93503 5.6245 7.51933 6.22659 7.93145C6.68452 8.24607 7.24301 8.41501 7.7825 8.57858C8.938 8.92784 9.40723 9.14067 9.40189 9.84549L9.40186 9.85069C9.40186 10.4423 8.61789 10.6526 7.94624 10.6526C7.3118 10.6526 6.62186 10.3745 6.23078 9.9611L5.26562 10.874C5.7609 11.3979 6.48048 11.7682 7.24321 11.9134V13H8.57178V11.9368C9.88407 11.7489 10.7287 10.9589 10.73 9.85372Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSignGray);
export default __webpack_public_path__ + "static/media/dollar-sign-gray.fbec1a2d.svg";
export { ForwardRef as ReactComponent };